// extracted by mini-css-extract-plugin
export default {"filterBar":"Products_filterBar__XM70n","filterBtn":"Products_filterBtn__M3TC+","filterActive":"Products_filterActive__9CbwE","grid":"Products_grid__GaRov"};